import { configureStore } from '@reduxjs/toolkit'
import authSlice from './slices/authSlice'
import principalSlice from './slices/principalSlice'

export default configureStore({
  reducer: {
    authSlice: authSlice.reducer,
    principalSlice: principalSlice.reducer
  }
})